<template>
  <Modal id="wc-popup-error" title="" @ok="ok">
    <template id="default">
      {{ message }}
    </template>
  </Modal>
</template>

<script>
import { mapState } from 'vuex'
import Modal from '@/components/Modal'

export default {
  components: {
    Modal
  },
  computed: mapState({
    show: ({ popupError }) => popupError.open,
    message: ({ popupError }) => popupError.message,
    onClose: ({ popupError }) => popupError.onClose,
  }),
  methods: {
    ok() {
      this.$store.commit('popupError/CLOSE')
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.$modal.show('wc-popup-error', { onClose: this.onClose })
      } else {
        this.$modal.close('wc-popup-error')
      }
    }
  }
}
</script>
